/* auto-generated: @mui/icons-material */
import Base from '@mui/icons-material/Login';
import {withMuiAdapter} from '@common/icons/with-mui-adapter';

export const LoginIcon = withMuiAdapter(Base, 'Login');
